import React from 'react';

import { OuterWrapper, ToggleBall, Wrapper } from './styles';

export interface Props {
  value?: boolean;
  title?: string;
  disabled?: boolean;
  handleChange: (value) => void;
}

const Toggle: React.FC<Props> = ({ value = false, title, disabled = false, handleChange }) => {
  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key == ' ') && !disabled) {
      handleChange(!value);
    }
  };

  const handleClick = () => {
    if (!disabled) {
      handleChange(!value);
    }
  };

  return (
    <OuterWrapper style={{ opacity: disabled ? 0.5 : 1 }}>
      {title && title}
      <Wrapper
        tabIndex={disabled ? -1 : 0}
        isLeft={!value}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        data-testid="toggle">
        <ToggleBall isLeft={!value}></ToggleBall>
      </Wrapper>
    </OuterWrapper>
  );
};

export default Toggle;
